module.exports = __webpack_public_path__ + "static/media/messenger-raven-token.46a8db2f.png";